import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuditSharedService } from 'src/app/services/Audit/audit-shared.service';
import { AuditOverviewService } from 'src/app/services/Audit/audit-overview.service';
import { UserModel } from 'src/app/Models';
import { AuditModel, CategoryIdsubauditorDTO } from 'src/app/Models/audit/audit.model';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuditdetailsserviceService } from '../auditdetailsservice.service';
import { ProjectStatusModel } from '../../../project-overview/models/project-status.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoaderService } from '../../../../../components/loader/loader.service'

@Component({
  selector: 'app-select-categories',
  templateUrl: './select-categories.component.html',
  styleUrls: ['./select-categories.component.css']
})
export class SelectCategoriesComponent {
  myControl = new FormControl('');
  projectStatusModel: ProjectStatusModel;
  auditModel: AuditModel;
  subauditorModel: CategoryIdsubauditorDTO;
  selectedProjectStatusId: any;
  categories: any;
  subauditor: any;
  filteredSubAuditorsName: Array<UserModel> = [];
  SubAuditorName: any[] = [];
  dropdownCombos: { categoryId: number; category: string; subAuditiorUserId: number; subAuditiorName: string }[] = [];
  showRemoveButton: boolean = false;
  filteredSubAuditors: any[];
  filteredCategories : any[];
  SubAuditorId: any;
  subAuditorName: string;
  auditdetails: any;
  currentDateTime = new Date();
  id: any;
  categoryId: number;
  showAuditorSelection: boolean = false;
  AuditorId: any;
  auditorName: string;
  auditId: number = 0;
  loginId: number = 0;

  constructor(
    private dialogref: MatDialogRef<SelectCategoriesComponent>, 
    @Inject(MAT_DIALOG_DATA) public data:any,
    private router: Router,
    private route: ActivatedRoute,
    private auditdetailsservice: AuditdetailsserviceService,
    private auditSharedService: AuditSharedService,
    private auditOverviewService: AuditOverviewService,
    public toaster: ToastrService,
    public loader: LoaderService,
  ) {
    this.currentDateTime = new Date();
    this.auditModel = new AuditModel();
  }

  ngOnInit() {
    this.getAuditId();
    this.getAuditdetailsbyAuditId(this.auditId);
    this.getProjectStatus();
    this.getCategories();
    this.getSubAuditorName();
    this.loginId = parseInt(localStorage.getItem('Id'));
  }

  getAuditId = () => {
    this.auditSharedService.getAuditId().subscribe((_auditId: number) => this.auditId = _auditId);
    this.auditId_MaintainState();
  }

  auditId_MaintainState = () => {
    if (this.auditId > 0) {
      localStorage.setItem('AuditId', this.auditId?.toString());
    }

    if (this.auditId < 1) {
      const id = parseInt(localStorage.getItem('AuditId'));
      this.auditId = (!isNaN(id)) ? id : this.auditId;
    }
  }

  getAuditdetailsbyAuditId(auditId: number) {
    this.auditdetailsservice.getAuditInfoByAuditId(auditId).subscribe(
      (response: any) => {
        this.auditdetails = response;
        this.AuditorId = response.auditiorUserId;
        this.showAuditorSelection = !response.auditiorName;
        this.dropdownCombos.push(...response.categoryDetails);
        console.log("dropdowns", this.dropdownCombos);
      });
  }

  getCategories() {
    this.auditOverviewService.getCategoryDropDown().subscribe(
      (response) => {
        if (response?.length > 0) {
          this.categories = response;
          this.filteredCategories = this.categories;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getProjectStatus() {
    this.auditOverviewService.getProjectStatus(this.auditId).subscribe(
      (responseData: ProjectStatusModel) => {
        this.projectStatusModel = responseData;
        this.selectedProjectStatusId = this.projectStatusModel.statusId;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  addCombo(): void {
    this.loader.isLoading.next(true);
    let allFilled = true; 
    const emptyRows: { index: number, categoryId: number, subAuditor: string }[] = [];
    const categoryIds = this.dropdownCombos.map(combo => combo.categoryId);
    const duplicateCategories = categoryIds.filter((item, index) => categoryIds.indexOf(item) !== index);
    this.dropdownCombos.forEach((combo, index) => {
      if (!combo.categoryId || !combo.subAuditiorName) {
        allFilled = false;
        emptyRows.push({ index, categoryId: combo.categoryId, subAuditor: combo.subAuditiorName });
      }
    });

    if (!allFilled) {
      emptyRows.forEach(row => {
        if(!row.categoryId && !row.subAuditor){
          this.toaster.error("Please select category and sub auditor.");
        }
        else if (!row.categoryId) {
          this.toaster.error("please select a category");
        }
        else if (!row.subAuditor) {
         this.toaster.error("please select a sub-auditor");
        }
      });
      this.loader.isLoading.next(false);
      return; 
    }
    if (duplicateCategories.length > 0) {
      this.toaster.error("Duplicate categories detected. Please select a different category.");
      this.loader.isLoading.next(false);
      return;
    }
    this.dropdownCombos.push({ categoryId: 0, category: '', subAuditiorUserId: 0, subAuditiorName: '' });
    this.showRemoveButton = this.dropdownCombos.length > 1;
  }

  validateCategory(index: number) {
    const selectedCategoryId = this.dropdownCombos[index].categoryId;
    
    // Check if the same category is selected in another row
    const isDuplicate = this.dropdownCombos.some((combo, i) => i !== index && combo.categoryId === selectedCategoryId);
    
    if (isDuplicate) {
        this.toaster.error("Duplicate category detected! Please select a different category.");
        this.dropdownCombos[index].categoryId = null; // Reset selection
        setTimeout(() => {
          this.dropdownCombos[index].categoryId = undefined; // Reset completely
      }, 10);
    }
  }
  
  getFilteredCategories(index: number): any[] {
    const selectedCategories = this.dropdownCombos.map(combo => combo.categoryId);
    return this.categories.filter(category => 
        category.id === this.dropdownCombos[index].categoryId || !selectedCategories.includes(category.id)
    );
  }

  getFilteredValues(event: string) {
    const specialCharsRegex = /[!#$%^&*_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (event && specialCharsRegex.test(event) || event.length < 3) {
      this.filteredSubAuditors = [];
    } else {
      const inputValue = event.toLowerCase();
      this.filteredSubAuditors = this.SubAuditorName.filter(auditor =>
        auditor.userName.toLowerCase().includes(inputValue)
      );
    }
  }

  getAuditorEmployeeId(selectedAuditor: string): number {
    const selected = this.SubAuditorName.find(auditor => auditor.userName === selectedAuditor);
    if (selected) {
      return selected.userId
    }
    ((this.auditorName == "") || (this.auditorName == undefined)) 
      ? this.toaster.error(`Please select an Auditor`)
      : this.toaster.error(`${this.auditorName} is not a valid employee`)
    return 0;
  }

  // this is not needed because you doing the same in the submit function transformedData.
  loadSubAuditors(selectedSubAuditor: string) {
    const selected = this.SubAuditorName.find(auditor => auditor.userName === selectedSubAuditor);
    if (selected) {
      this.SubAuditorId = selected.userId;
    }
  }

  getSubAuditorName() {
    this.auditdetailsservice.getAuditorName()
      .subscribe((response: any) => {
        this.SubAuditorName = response;
        this.filteredSubAuditors = this.SubAuditorName;
      });
  }

  removeCombo(index: number): void {
    this.dropdownCombos.splice(index, 1);
    this.showRemoveButton = this.dropdownCombos.length > 1;
  }

  mapAuditInfo() {
    this.auditModel.projectId = this.auditdetails.projectId;
    this.auditModel.TechStackIds = this.auditdetails.technologyStackDTODetails != undefined ? this.auditdetails.technologyStackDTODetails.map(tsd => tsd.stackId) : [];
    this.auditModel.managerId = this.auditdetails.managerId;
    this.auditModel.deliveryManagerId = this.auditdetails.deliveryManagerId;
    this.auditModel.auditorId = this.auditdetails.auditiorUserId; //check wheather we can remove this or not.
    this.auditModel.createdBy = this.auditdetails.createdBy;
    this.auditModel.createdDate = this.auditdetails.createdDate;
  }

  submit(value: any, isSubmit: boolean): void {
    var isExit = false;
    if (this.showAuditorSelection) {
      this.AuditorId = this.getAuditorEmployeeId(this.auditorName);
    }
    if (value.length == 0) {
      this.toaster.error("Please select atleast 1 categrory");
      return
    }
    const filteredValue = value.filter(item => {
      if ((!item.categoryId && item.subAuditiorName) || (item.categoryId && !item.subAuditiorName)) {
        this.toaster.error((!item.categoryId && item.subAuditiorName) 
                              ? `Error: Select a category for ${item.subAuditiorName}`
                              : `Error: Select a subAuditor for ${item.categoryId} id`); 
        isExit = true;
        return false; 
      } else if (!item.categoryId && !item.subAuditiorName) { 
        return false; 
      }
      return true; 
    });
    if (isExit || this.AuditorId == 0) {
      return;
    }
    const transformedData = filteredValue.map(item => ({
      CategoryId: item.categoryId,
      SubAuditorID: this.SubAuditorName.find(auditor => auditor.userName === item.subAuditiorName).userId //what if you dont find any employeeId
    }));
    if (this.auditId) {
      this.auditModel.auditId = this.auditId;
      this.auditModel.modifiedBy = this.loginId;
      this.auditModel.modifiedDate = this.currentDateTime;
      this.mapAuditInfo();
      this.auditModel.auditorId = this.AuditorId;
      this.auditModel.CategoryIdsubauditorDTO = transformedData;
    }
    this.auditModel.statusId = isSubmit ? 5 : 4;
    this.auditdetailsservice.saveAuditcreation(this.auditModel).subscribe(
      (response) => {
        this.toaster.success("Audit details Saved/Updated Successfully.");
        isSubmit ? setTimeout(() => { this.router.navigate(['Home/Audit']); }, 500) : window.location.reload();
      },
      (error) => {
        console.log('errors : ', error);
        this.toaster.error("Audit details not Saved/Updated Successfully.");
      }
    );
  }

  onCancel() {
    this.dialogref.close();
  }
}